import DayTimePillPopup, {DayTimePillPopupProps} from './DayTimePillPopup'

export type {DayTimePillPopupProps}
export default DayTimePillPopup
